<template>
  <div>
    <button
      data-gtm-action="show nutrition info"
      :data-gtm-label="productTitle"
      @click.prevent="handleClick"
    >
      <slot />
    </button>
    <VueModal
      v-if="product"
      v-model="modalActive"
      @close="modalActive = false"
    >
      <ProductNutritionModal
        :product="product"
        @close="modalActive = false"
      />
    </VueModal>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import VueModal from '@/components/theme/render/vue-modal.vue'
import ProductNutritionModal from '@/components/products/product-nutrition-modal.vue'
import { useProductsStore } from '@/stores'
export interface Props {
  productId: string
  productTitle: string
}
const props = defineProps<Props>()
const modalActive = ref(false)
const product = ref()

const store = useProductsStore()

const handleClick = () => {
  product.value = store.productList.find(p => String(p.id) === props.productId)
  modalActive.value = true
}
</script>
